
<div class="products-container">
  <div class="page-header">
    <h1 class="page-title">Menu Days</h1>

    <div class="header-actions">
      <button class="btn-add-reservation" (click)="sendToPrint()">Print</button>
      <select class="day-select" [(ngModel)]="selectedDay" (change)="onDayChange()">
        <option *ngFor="let day of days" [ngValue]="day.value">
          {{ day.label }}
        </option>
      </select>

      <input type="text" placeholder="Search products..." class="search-input" (input)="onSearch($event)" />

      <button class="btn-add-reservation" (click)="pickerOpen = true">
        <span class="btn-icon">➕</span>
        <span class="btn-text">Add New Products To Day</span>
      </button>
      <button class="btn-add-reservation" (click)="prepPopupModalAll()">

        🗑️
        Remove All

      </button>

    </div>
  </div>

  <div class="products-table">
    <div class="table-header">
      <div class="header-cell image-cell">Image</div>
      <div class="header-cell name-cell">Product Name</div>
      <div class="header-cell schedule-cell">Days and Times</div>
      <div class="header-cell">Barcode</div>
      <!-- <div class="header-cell">Min</div>
      <div class="header-cell">Allocated Product</div>
      <div class="header-cell">Max</div> -->
      <!-- <div class="header-cell">Allocated</div> -->
      <div class="header-cell actions-cell">Actions</div>
    </div>

    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading products...</p>
    </div>

    <div class="table-body" *ngIf="!isLoading">
      <ng-container *ngFor="let item of filteredProducts">
        <div class="product-row">
          <div class="cell image-cell">
            <img [src]="item.thumbnail_image | ImageUrlPipe" [alt]="item.name" class="product-image" appImageFallback />
          </div>

          <div class="cell name-cell">
            <div class="product-name">{{ item.name }}</div>

            <div class="product-meta">
              <span class="meta-item">
                <span class="meta-label">Price:</span>
                <span class="meta-value">
                  {{ item.stroked_price | currency }}
                </span>
              </span>

              <span class="meta-item">
                <span class="meta-label">Rating:</span>
                <span class="meta-value">{{ item.rating || 0 }}</span>
              </span>
            </div>
          </div>

          <div class="cell day-cell schedule-cell">
            <div class="days-summary">
              {{ item.menue_days_text }}
            </div>

            <div class="days-schedules">
              <div class="day-schedule-row" *ngFor="let day of reservationDays">
                <label class="day-check">
                  <input type="checkbox" [checked]="isDaySelected(item, day.value)" (change)="
                      toggleProductDay(
                        item,
                        day.value,
                        $any($event.target).checked
                      )
                    " />
                  <span>{{ day.label }}</span>
                </label>

                <!-- <div class="day-time-range" *ngIf="getMenuDay(item, day.value) as schedule">
                  <label class="time-field">
                    <span>Start</span>
                    <input type="datetime-local" class="time-input datetime-input" [(ngModel)]="schedule.start_time"
                      (ngModelChange)="markDirty(item)" (blur)="onMenuTimeChange(item)" />
                  </label>

                  <span class="time-separator">→</span>

                  <label class="time-field">
                    <span>End</span>
                    <input type="datetime-local" class="time-input datetime-input" [(ngModel)]="schedule.end_time"
                      (ngModelChange)="markDirty(item)" (blur)="onMenuTimeChange(item)" />
                  </label>
                </div> -->

                <div class="day-time-range" *ngIf="getMenuDay(item, day.value) as schedule">

                  <!-- Start -->
                  <label class="time-field">

                    <span>Date</span>

                    <input type="date" class="time-input datetime-input" value="{{currnetWeek[day.value-1].split('T')[0]}}"
                      readonly />

                  </label>
                  <label class="time-field">

                    <span>Start</span>

                    <input type="time" class="time-input datetime-input" [(ngModel)]="schedule.start_time"
                      (ngModelChange)="markDirty(item)" (blur)="onMenuTimeChange(item)"/>

                  </label>


                  <span class="time-separator">
                    →
                  </span>


                  <!-- End -->
                  <label class="time-field">

                    <span>End</span>

                    <input type="time" class="time-input datetime-input" [(ngModel)]="schedule.end_time"
                      (ngModelChange)="markDirty(item)" (blur)="onMenuTimeChange(item)" />

                  </label>


                  <!-- Min -->
                  <label class="time-field">

                    <span>Min</span>

                    <input type="number" class="qty-input" [(ngModel)]="schedule.min_qty"
                      (ngModelChange)="markDirty(item)" (blur)="onDayQtyChange(item, schedule)" min="0" />

                  </label>


                  <!-- Quantity -->
                  <label class="time-field">

                    <span>Quantity</span>

                    <input type="number" class="qty-input" [(ngModel)]="schedule.prod_qty"
                      (ngModelChange)="markDirty(item)" (blur)="onDayQtyChange(item, schedule)"
                      [min]="schedule.alloc_qty" />

                  </label>


                  <!-- Max -->
                  <label class="time-field">

                    <span>Max</span>

                    <input type="number" class="qty-input" [(ngModel)]="schedule.max_qty" (ngModelChange)="onDayMaxQtyChange(
        item,
        schedule,
        $event
      )" (blur)="onDayQtyChange(item, schedule)" min="0" [max]="schedule.prod_qty" />

                  </label>


                  <!-- Allocated -->
                  <!-- <label class="time-field">

                    <span>Allocated</span>

                    <input type="number" class="qty-input" [value]="schedule.alloc_qty" disabled />

                  </label> -->

                </div>









              </div>
            </div>

            <div class="schedule-error" *ngIf="item._scheduleError">
              {{ item._scheduleError }}
            </div>
          </div>

          <div class="cell">{{ item.barcode || 'N/A' }}</div>

          <!-- <div class="cell">
            <input type="number" class="qty-input" [(ngModel)]="item.min_qty" (ngModelChange)="markDirty(item)"
              (blur)="onQtyChange(item)" min="0" />
          </div>

          <div class="cell">
            <input type="number" class="qty-input" [(ngModel)]="item.prod_qty" (ngModelChange)="markDirty(item)"
              (blur)="onQtyChange(item)" min="0" />
          </div> -->

          <!-- <div class="cell"> -->
          <!-- <input
              type="number"
              class="qty-input"
              [(ngModel)]="item.max_qty"
              (ngModelChange)="markDirty(item)"
              (blur)="onQtyChange(item)"
              min="0"
            /> -->

          <!-- <input type="number" class="qty-input" [(ngModel)]="item.max_qty"
              (ngModelChange)="onMaxQtyChange(item, $event)" (blur)="onQtyChange(item)" min="0" [max]="item.prod_qty" /> -->


          <!-- </div> -->

          <!-- <div class="cell allocated-cell">
            <span class="allocated-badge" *ngFor="let stock of item.stock">
              <small>{{ stock.store_name }}</small>
              <strong>{{ stock.alloc_qty }}</strong>
            </span>
          </div> -->

          <div class="cell actions-cell">

            <!-- <button 
    class="btn-edit" 
    (click)="openStockModal(item)"
    title="Transfer Product">

    <i class="fa-duotone fa-solid fa-truck"></i>
    Transfer

  </button> -->


            <button class="btn-delete" (click)="prepPopupModalItem(item)" title="Remove from menu day">

              🗑️
              Remove

            </button>

          </div>



        </div>
      </ng-container>

      <div class="empty-state" *ngIf="filteredProducts.length === 0">
        <div class="empty-icon">📦</div>
        <p class="empty-text">No products found</p>
        <p class="empty-subtext">
          Try adjusting your search or change the day filter.
        </p>
      </div>
    </div>
  </div>

  <div class="pagination-container" *ngIf="!isLoading && filteredProducts.length > 0">
    <div class="pagination-info">
      Showing <strong>{{ getStartIndex() }}</strong>
      to <strong>{{ getEndIndex() }}</strong>
      of <strong>{{ totalItems }}</strong> products
    </div>

    <div class="pagination-controls">
      <button class="page-btn prev-btn" (click)="previousPage()" [disabled]="currentPage === 1 || isLoading"
        title="Previous Page">
        ‹
      </button>

      <button *ngIf="currentPage > 3" class="page-btn page-number" (click)="goToPage(1)" [disabled]="isLoading">
        1
      </button>

      <span class="ellipsis" *ngIf="currentPage > 3">...</span>

      <button *ngFor="let page of getPageNumbers()" class="page-btn page-number" [class.active]="page === currentPage"
        [disabled]="isLoading" (click)="goToPage(page)">
        {{ page }}
      </button>

      <span class="ellipsis" *ngIf="currentPage < totalPages - 2">
        ...
      </span>

      <button *ngIf="currentPage < totalPages - 2 && totalPages > 1" class="page-btn page-number"
        (click)="goToPage(totalPages)" [disabled]="isLoading">
        {{ totalPages }}
      </button>

      <button class="page-btn next-btn" (click)="nextPage()" [disabled]="currentPage === totalPages || isLoading"
        title="Next Page">
        ›
      </button>
    </div>
  </div>
</div>

<app-product-day-picker-modal [isOpen]="pickerOpen" (close)="pickerOpen = false"
  (saved)="onPickerSaved($event)"></app-product-day-picker-modal>

<div class="modal-backdrop" *ngIf="showStockModal">
  <div class="modal stock-modal">
    <div class="modal-header">
      <h3>Stock Details - {{ selectedProduct?.name }}</h3>
      <button class="close-btn" (click)="closeStockModal()">✖</button>
    </div>

    <div class="modal-body">
      <div class="stock-row" *ngFor="let stock of selectedProduct?.stock; let index = index">
        <div class="stock-info">
          <strong>{{ stock.store_name }}</strong>
          <span>Requested: {{ stock.alloc_qty }}</span>
        </div>

        <div class="stock-inputs">
          <label>
            <span>Allocated</span>
            <input type="number" class="stock-input" [(ngModel)]="stock.alloc_qty" placeholder="Allocated" min="0" />
          </label>

          <label>
            <span>Stocked</span>
            <input type="number" class="stock-input" placeholder="Stocked" #stock_qty [min]="stock.alloc_qty"
              [value]="stock.alloc_qty" />
          </label>
        </div>

        <span class="error-message" *ngIf="stockErrors[index]">
          {{ stockErrors[index] }}
        </span>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeStockModal()">Cancel</button>
      <button class="btn-save" (click)="saveStock()">Save</button>
    </div>
  </div>
</div>



@if(showModalItem){
<app-confirm-modal title={{popupModalArgs.title}} message={{popupModalArgs.message}}
  confirmLabel={{popupModalArgs.confirmLabel}} cancelLabel={{popupModalArgs.cancelLabel}} [destructive]="true"
  (confirmed)="removeFromMenuDay(selectedItem)" (cancelled)="showModalItem = false" />
}@else if(showModalAll){
<app-confirm-modal title={{popupModalArgs.title}} message={{popupModalArgs.message}}
  confirmLabel={{popupModalArgs.confirmLabel}} cancelLabel={{popupModalArgs.cancelLabel}} [destructive]="true"
  (confirmed)="removeAllFromMenuDay()" (cancelled)="showModalAll = false" />
}@else if(showModalConfirm){
<app-confirm-modal title={{popupModalArgs.title}} message={{popupModalArgs.message}}
  confirmLabel={{popupModalArgs.confirmLabel}} cancelLabel={{popupModalArgs.cancelLabel}} [destructive]="false"
  (confirmed)="showModalConfirm=false" (cancelled)="showModalAll = false" />
}


@if(showPrintModal){
<app-print-modal [title]="printTitle" [columns]="columns" [rows]="ordersPrint" (closed)="showPrintModal = false" />
}